import RegisterComponent from '../components/auth/register';

export default function Register() {
  return <RegisterComponent />;
}
